module.exports = __webpack_public_path__ + "img/osl-IMG_7519.df74c547.jpg";